import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 10px;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  color: var(--if-ink-3);
  transition: all 0.15s ease;

  ${({ copied }) =>
    copied &&
    `
    color: var(--if-diff-add-ink);
    background: var(--if-diff-add-bg);
    border-color: var(--if-diff-add-border);
  `}

  &:hover {
    color: var(--if-ink-2);
  }
`;

export default function CopyButton({ value }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(() => {
    const text =
      typeof value === 'string' ? value : JSON.stringify(value, null, 2);
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  }, [value]);

  return (
    <StyledButton type="button" onClick={handleCopy} copied={copied}>
      {copied ? '✓ copied' : 'copy'}
    </StyledButton>
  );
}

CopyButton.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.object,
  ]).isRequired,
};
